import type { CollectedPageMeta } from "~/utils/seo/collectPageMeta";

/**
 * Отправка реальной меты страницы в nestFarkopDatabase.
 * Где вызывается: клиент (hooks/usePageMetaTracking).
 */
export default (axios: any, config: any) => ({
  async track(meta: CollectedPageMeta) {
    const response = await axios.post(
      `${config.SERVICE_DATABASE_API_URL}/page-meta-tracking/track`,
      meta,
    );
    return response?.data ?? { ok: false };
  },
});
